import react from 'react'
import vc2 from './../../images/vc2.jpg'
import {Link } from 'react-router-dom'
import './home2.css'

const First_Pane =() =>(
     <div>
         <div className=''
           style={{ 
            backgroundImage: `-webkit-linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(${vc2})`,
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(${vc2})`,
                  
           backgroundRepeat: 'no-repeat',
           backgroundSize: 'cover',
           paddingBottom: '250px',
           paddingTop: '100px',
           height: 'auto'
       }}>
                       
                       <div className='uk-container uk-margin-xlarge-top'>
                            <div className='uk-grid'>
                    <div className='uk-width-3-5@s' uk-scrollspy="cls: uk-animation-slide-left; repeat: true">

                    <h1 className='light uk-text-bold hero_header'>We design and build modern <span style={{color:'#3bcbee'}}>structures</span> </h1>
                  
                    </div>

                    <div className='uk-width-2-5@s'>

                    </div>
                </div>

                <div className='uk-margin-xlarge-top'>
                    <div className='ctaHero'>
                  <Link to="/biote_aqua">See our Projects</Link>
                    </div>
                </div>


            </div>
              





        </div>
     </div>
)


export default First_Pane